import {defineStore} from 'pinia'
import {useApiRequestStore} from '@toolify/client/src/stores/ApiRequestStore/useApiRequestStore'
import {IToJson} from '@toolify/client/src/types/IToJson'
import {PermissionEntityType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionEntityType'
import {
  IViewAsSessionResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IViewAsSessionResponseInstance'
import {
  IStartViewAsSessionRequestInterfaces,
} from '@toolify/server/src/controllers/ViewAsController/validators/StartViewAsSession/types/IStartViewAsSessionRequestInterfaces'
import {
  IEndViewAsSessionRequestInterfaces,
} from '@toolify/server/src/controllers/ViewAsController/validators/EndViewAsSession/types/IEndViewAsSessionRequestInterfaces'
import {
  IGetWorkspaceViewAsSessionsRequestInterfaces,
} from '@toolify/server/src/controllers/ViewAsController/validators/GetWorkspaceViewAsSessions/types/IGetWorkspaceViewAsSessionsRequestInterfaces'
import {
  IGetMyViewAsSessionsRequestInterfaces,
} from '@toolify/server/src/controllers/ViewAsController/validators/GetMyViewAsSessions/types/IGetMyViewAsSessionsRequestInterfaces'

export const useViewAsApiStore = defineStore('viewAsApi', {
  actions: {
    async startViewAsSession(
      workspaceId: string,
      targetEntityType: PermissionEntityType,
      targetEntityId: string,
    ): Promise<IToJson<IStartViewAsSessionRequestInterfaces['response']>> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.post<IStartViewAsSessionRequestInterfaces>(
        `/workspace/${workspaceId}/view-as`,
        {
          data: {
            targetEntityType,
            targetEntityId,
          },
        },
        {
          withoutViewAs: true,
        },
      )
    },

    async endViewAsSession(sessionId: string): Promise<IToJson<IEndViewAsSessionRequestInterfaces['response']>> {
      const apiRequestStore = useApiRequestStore()
      return await apiRequestStore.delete<IEndViewAsSessionRequestInterfaces>(
        `/view-as/${sessionId}`,
        undefined,
        {
          withoutViewAs: true,
        },
      )
    },

    async getWorkspaceViewAsSessions(workspaceId: string): Promise<IToJson<IViewAsSessionResponseInstance>[]> {
      const apiRequestStore = useApiRequestStore()
      const {sessions} = await apiRequestStore.get<IGetWorkspaceViewAsSessionsRequestInterfaces>(
        `/workspace/${workspaceId}/view-as/sessions`,
      )
      return sessions
    },

    async getMyViewAsSessions(): Promise<IToJson<IViewAsSessionResponseInstance>[]> {
      const apiRequestStore = useApiRequestStore()
      const {sessions} = await apiRequestStore.get<IGetMyViewAsSessionsRequestInterfaces>('/me/view-as/sessions')
      return sessions
    },
  },
})
